import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Select, Button, Modal, Spin, Tooltip, Badge, message, Alert, Space, Popconfirm } from "antd";
import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";
import axios from "axios";
import moment from "moment";

import qs from 'querystring'

import { debounce } from 'lodash'; 

import { DESKTOP_DOWN } from "../../config/mediaQueries";
import { API_ERRO_TYPE_CANCEL } from "./../../config/general";
import { timeCardService, columnsService, employeesService, companiesService } from "./../../redux/services";
import * as floatbox from "./../../helpers/floatbox";
import { formatHours, toMinutes } from "./../../helpers/hours";
import { icones_status } from "../../enum/status";
import UIKpiCards from "./../../components/KpiCards";
import Table from "./Table";
import ModalColumns from "./ModalColumns";
import ModalCreate from "./ModalCreate";
import ModalEdit from "./ModalEdit";
import ModalDiscard from "./ModalDiscard";
import ModalAjustes from "./ModalAjustes";
import ModalBancoAjustes from "./ModalBancoAjustes";
import ModalFilters from "./filters";
import ModalJourneyShow from "../Journeys/show";
import FloatBox from "./floatBox";
import {
	DatePickerWithMask,
	UIAvatarLabel,
	UIPageListing,
} from "./../../components";
import ModalSendToSign from "./ModalSendToSign";
import ModalListSigned from "./ModalListCartoesAssinados";
import ModalJustificationRequest from "./ModalJustificationRequests";

const config = {
	title: "Cartão Ponto",
	subtitle: "Visualize e gerencie os registros de ponto dos funcionários.",
	icon: <i className="fal fa-calendar-alt" />,
	permissionPrefix: "cartao-ponto",
};

const CELL_WIDTH = 80;

const groups = {
	punches : "Registros de ponto",
	results : "Apuração",
	overtime: "Horas extras",
	bank    : "Banco de horas",
};

const overtimePeriods = [
	{ key: "diurno", label: "Diurna", summaryLabel: "Diurnas" },
	{ key: "noturno", label: "Noturna", summaryLabel: "Noturnas" },
	{ key: "intervalo", label: "Intervalo", summaryLabel: "Intervalo" },
];

const overtimePeriodIndex = (periodo) => overtimePeriods.findIndex((period) => period.key === periodo);

const signClass = (minutes) => minutes < 0 ? "is-negative" : (minutes > 0 ? "is-positive" : "");

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSearching: false,
			isDisabled: true,
			data: [],
			dataTotal: {},
			pagination: {
				current: 1,
				pageSize: 50,
				total: 0,
			},
			// Actions
			columnsModalVisible: false,
			ajustesModalVisible: false,
			bancoAjustesModalVisible: false,
			filtersModalVisible: false,
			modalSendToSignVisible: false,
			modalSignedCardsVisible: false,
			modalJustificationRequests: false,
			allowSendToSign: false,
			activeLoadings: [],
			// Media queries
			desktopDown: false,

			//Companies
			companies: [],

			//App request
			justificationRequests: [],
			pontoAjusteRequests: [],
			loadingApproveRequests: false,
			loadingRejectRequests: false,

  		companiesIsLoading: false,

			employees: [],
			employeeData: {
				page: 1,
				pages: 1,
				total: 0
			},
			employeesIsLoading: false,
			allEmployees: [],

			isPreviousDisabled: true,
			isNextDisabled: false,

			joinColumns: [],
			dynamicColumns: [],
			overtimeColumns: [],

			columnsList: [],
			maxJoinColumns: 0,
			avatar: "",

			// Filters
			empresa_id: "",
			funcionario_id: "",
			dataInicial: moment().startOf("month").format("YYYY-MM-DD"),
			dataFinal: moment().format("YYYY-MM-DD"),
			motivo: "",
			currentEmployeeDepartment: '',

			filters: {
				empresa_id: null,
				departamento_id: null,
				funcao_id: null,
				jornada_id: null,
				status: null
			},

			journeyShowModalVisible: false,
			dataFinalError: false,
		};
		this.fetchingNextPage = false;
		this.navigationTimeout = null;
		this._axiosCancelEmployeesToken = null;
		this._axiosCancelDataToken = null;
		this._axiosCancelJustificationRequestToken = null;
		this._axiosCancelPontoAjusteRequestToken = null;
	}

	componentDidMount() {
		if (!this.state.companies.length) {
			this.fetchCompanies(this.loadFirstCompany);
			this.fetchEmployees('0', true, this.loadFirstEmployee);
		}

		// Listen Media Querie sideBar
		enquire.register(DESKTOP_DOWN, {
			match: () => {
				this.setState({
					desktopDown: true,
				})
			},
			unmatch: () => {
				this.setState({
					desktopDown: false,
				})
			}
		});
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevState.empresa_id !== this.state.empresa_id) {
			this.fetchEmployees('0', true, this.loadFirstEmployee);
		}
	}

	componentWillUnmount() {
		// Unlisten Media Querie sideBar
		enquire.unregister(DESKTOP_DOWN);
	};

	fetchSolicitacoesJustificativas = () => {
		if ( this._axiosCancelJustificationRequestToken ) {
			this._axiosCancelJustificationRequestToken.cancel("Only one request allowed at a time.");
		}

		const { 
			funcionario_id, 
			empresa_id, 
		} = this.state;

		if (!empresa_id || !funcionario_id) return;

		this._axiosCancelJustificationRequestToken = axios.CancelToken.source();

		timeCardService.listarSolicitacoesJustificativa({
			funcionario_id,
			empresa_id,
			cancelToken: this._axiosCancelJustificationRequestToken,
		}).then((data) => {
			this.setState({
				justificationRequests: data.data,
			})
		}).catch((error) => {
			if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(error),
			});
		})
	}

	approveAllJustificationRequest = (aprove) => {
		const { 
			funcionario_id, 
			empresa_id, 
			dataInicial, 
			dataFinal,
			justificationRequests,
			pontoAjusteRequests, 
		} = this.state;

		if (aprove) {
			this.setState({ loadingApproveRequests: true });
		} else {
			this.setState({ loadingRejectRequests: true });
		}

		if (Array.isArray(justificationRequests) && justificationRequests.length > 0) {
			timeCardService.updateSolicitacaoJustificativa({
				funcionario_id,
				empresa_id,
				atualizar_todas: true,
				status_aprovacao: aprove ? 'aprovado' : 'recusado',
			}).then((data) => {
				message.success(`Solicitações de justificativa ${aprove ? 'aprovadas' : 'recusadas'} com sucesso!`);
				if (aprove) {
					this.setState({ loadingApproveRequests: false });
				} else {
					this.setState({ loadingRejectRequests: false });
				}
				this.fetchGetAll(true);
			})
			.catch((error) => {
				this.setState({ 
					loadingApproveRequests: false,
					loadingRejectRequests: false,
				});

				if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

				Modal.error({
					title  : "Ocorreu um erro!",
					content: String(error),
				});
			})
		}

		if (Array.isArray(pontoAjusteRequests) && pontoAjusteRequests.length > 0) {
			timeCardService.updateSolicitacaoPontoAjuste({
				funcionario_id,
				empresa_id,
				atualizar_todas: true,
				status_aprovacao: aprove ? 'aprovado' : 'recusado',
			}).then((data) => {
				message.success(`Solicitações de justificativa ${aprove ? 'aprovadas' : 'recusadas'} com sucesso!`);
				if (aprove) {
					this.setState({ loadingApproveRequests: false });
				} else {
					this.setState({ loadingRejectRequests: false });
				}
				this.fetchGetAll(true);
			})
			.catch((error) => {
				this.setState({ 
					loadingApproveRequests: false,
					loadingRejectRequests: false,
				});

				if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

				Modal.error({
					title  : "Ocorreu um erro!",
					content: String(error),
				});
			})
		}
	}

	justificationRequestsClose = (fetchJustifications, fetchTimeCard) => {
		this.setState({ modalJustificationRequests: false });

		if (fetchTimeCard) this.fetchGetAll(true);
		if (fetchJustifications) {
			this.fetchSolicitacoesJustificativas();
			this.fetchSolicitacoesPontoAjuste();
		}
	}

	
	fetchSolicitacoesPontoAjuste = () => {
		if ( this._axiosCancelJustificationRequestToken ) {
			this._axiosCancelJustificationRequestToken.cancel("Only one request allowed at a time.");
		}

		const { 
			funcionario_id, 
			empresa_id, 
		} = this.state;

		if (!empresa_id || !funcionario_id) return;

		this._axiosCancelJustificationRequestToken = axios.CancelToken.source();

		timeCardService.listarSolicitacoesPontoAjuste({
			funcionario_id,
			empresa_id,
			cancelToken: this._axiosCancelJustificationRequestToken,
		}).then((data) => {
			this.setState({
				pontoAjusteRequests: data.data,
			})
		}).catch((error) => {
			if( error.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(error),
			});
		})
	}

	fetchCompanies = (callback) => {
		if( this._axiosCancelCompaniesToken )
		{
			this._axiosCancelCompaniesToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelCompaniesToken = axios.CancelToken.source();

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAutocomplete({
			orderBy    : "nome:asc",
			cancelToken: this._axiosCancelCompaniesToken.token,
		})
		.then((response) => {
			this.setState({
				companiesIsLoading: false,
				companies: response.data.data,
			}, () => {
				if (typeof callback === 'function') {
					callback();
				}
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				companiesIsLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	fetchEmployees = debounce((value, funcionario_id = false, callback, page = 1) => {
		if (this._axiosCancelEmployeesToken) {
			this._axiosCancelEmployeesToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelEmployeesToken = axios.CancelToken.source();

		// if (!value.trim().length) {
		// 	this.setState({
		// 		employeesIsLoading: false,
		// 		employees: [],
		// 	});

		// 	return false;
		// }

		const { filters, allEmployees } = this.state;

		const empresa_id      = this.state.empresa_id;
		const departamento_id = filters.departamento_id;
		const jornada_id      = filters.jornada_id;
		const funcao_id       = filters.funcao_id;
		const status          = filters.status;

		this.setState({
			employeesIsLoading: true,
		});

		let params = {
			search: value,
			orderBy: "nome:asc",
			page,
			cancelToken: this._axiosCancelEmployeesToken.token,
		};

		if (empresa_id) params.empresas_ids = [empresa_id];
		if (departamento_id) params.departamentos_ids = [departamento_id];
		if (jornada_id) params.horarios_ids = [jornada_id];
		if (funcao_id) params.funcao_ids = [funcao_id];
		if (status) params.status = status;

		employeesService.getAutocomplete({
			...params,
		}).then((response) => {
			const { data: employees, ...employeeData } = response.data || {};

			if (allEmployees.length === 0) {
				this.setState({
					allEmployees: employees,
				});
			}

			const new_employees = (page > 1) ? [...this.state.employees, ...employees] : [...employees];

			this.setState({
				employeesIsLoading: false,
				employees: new_employees,
				employeeData,
			}, () => {
				if (callback) callback(employees);
			});
		})
		.catch((data) => {
			if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

			this.setState({
				employeesIsLoading: false,
			});

			Modal.error({
				title: "Ocorreu um erro!",
				content: String(data),
			});
		});
	}, 500);

	loadFirstEmployee = () => {
		const { employees } = this.state;
		const [employee] = employees;
		this.selectEmployee(employee?.id);
	}

	loadFirstCompany = () => {
		const { companies } = this.state;
		const [company] = companies;
		this.selectCompany(company?.id);
	}
	
	selectCompany = (empresa_id, paginate = false) => {
		const { companies } = this.state;
		const currentIndex = companies.findIndex((company) => company.id === empresa_id);

		if (this.form && this.form.setFieldValue) {
			this.form.setFieldValue("empresa_id", empresa_id);
		}

		this.setState({
			allEmployees: [],
			empresa_id,
			isPreviousDisabled: currentIndex <= 0,
			isNextDisabled: currentIndex >= (companies.length - 1),
		}, () => {
			this.fetchGetAll(paginate);
		});
	}

	selectEmployee = (funcionario_id, paginate = false) => {
		const { employees, employeeData } = this.state;
		const { page = 1, pages = 1 } = employeeData || {};
	
		const selectedEmployee = employees.find((employee) => employee.id === funcionario_id);
		const currentIndex = employees.findIndex((employee) => employee.id === funcionario_id);
		const isInEmployees = employees.some((employee) => employee.id === funcionario_id);
		const updatedEmployees = (!isInEmployees && selectedEmployee) ? [...employees, selectedEmployee] : employees;
	
		if (this.form && this.form.setFieldValue) this.form.setFieldValue("funcionario_id", funcionario_id);
	
		this.setState({
			funcionario_id,
			avatar: selectedEmployee?.avatar,
			currentEmployeeDepartment: selectedEmployee?.contrato[0]?.departamento_id,
			isPreviousDisabled: currentIndex <= 0,
			isNextDisabled: pages > page ? currentIndex > (employees.length - 1) : currentIndex >= (employees.length - 1),
			employees: updatedEmployees,
			allowSendToSign: selectedEmployee?.permitir_assinar_cartao_app,
		}, () => {
			this.fetchGetAll(paginate);
		});
	};			

	fetchGetAll = (paginate = false) => {
		const { dataInicial, dataFinal } = this.state;
		this.fetchGetItems(paginate, dataInicial, dataFinal, true);
		this.fetchSolicitacoesJustificativas();
		this.fetchSolicitacoesPontoAjuste();
	}

	mergeData = item => ({
		...item,
		_ajuste_horas_falta: this.formatTime(item.ajuste_horas_falta),
		possui_batidas: this.checkBatidas(item),
	});

	reloadAll = (state, response, hasReset) => {
		if (hasReset) {
			return { 
				data:
					response.data?.data?.map((item) => this.mergeData(item)) || [],
				pagination: {
					...state.pagination,
					current: response.data?.meta?.current_page || 1,
					total: response.data?.meta?.total || 0,
				},
			};
		}

		const novaLista = state.data.map(item => {
			const element = response.data?.data.find(cartao => cartao.id === item.id);
			return element || item;
		});

		return { 
			data: novaLista?.map((item) => this.mergeData(item)) || [],			
		};
	}

	fetchGetItems = (paginate = false, dataInicialStep, dataFinalStep, hasReset = true, page = null) => {
		const { 
			isLoading, 
			isDisabled, 
			pagination, 
			funcionario_id, 
			filters, 
			empresa_id, 
			dataInicial: dataInicialOriginal, 
			dataFinal: dataFinalOriginal 
		} = this.state;

		const newPage = page || pagination.current;

		// if (isLoading && isDisabled) return;
		if (this._axiosCancelDataToken) {
			this._axiosCancelDataToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelDataToken = axios.CancelToken.source();

		const dataInicial = moment(dataInicialStep).isBefore(moment(dataInicialOriginal)) ? dataInicialOriginal : dataInicialStep;
		const dataFinal = moment(dataFinalStep).isAfter(moment(dataFinalOriginal)) ? dataFinalOriginal : dataFinalStep;

		// Hide all floatbox
		floatbox.hideAll();

		this.setState({ isDisabled: true, isLoading: true, isSearching: true }, () => {
			const data = {
				funcionario_id,
				datainicial: dataInicial || moment().startOf("month").format("YYYY-MM-DD"),
				datafinal: dataFinal || moment().format("YYYY-MM-DD"),
				empresa_id: empresa_id || null,
				departamento_id: filters?.departamento_id || null,
				funcao_id: filters?.funcao_id || null,
				jornada_id: filters?.jornada_id || null,
				status: filters?.status || null,
				page: paginate ? newPage : 1,
				limit: pagination.pageSize,
			}
			
			if (!paginate || !data.funcionario_id || !data.empresa_id) this.resetTable(true);
			if (!data.empresa_id || !data.funcionario_id) {
				this.setState({ isLoading: false, isDisabled: false });
				return;
			}

			timeCardService.getAllTimeCards(data, this._axiosCancelDataToken.token)
				.then((response) => {
					this.setState(state => this.reloadAll(state, response, hasReset), async () => {
						if(response.data?.data?.length > 0) {
							await this.handleGetColumnsList(data, response.data.data[0]?.contrato, paginate, response?.data?.totais);
						} else if (hasReset) {
							this.setState({ dataTotal: {} });
						}
						this.setState({ isLoading: false,  isDisabled: false });
					});
				})
				.catch((data) => {
					if (data.error_type === API_ERRO_TYPE_CANCEL) return null;
					this.resetTable();
					Modal.error({
						title: "Ocorreu um erro!",
						content: String(data),
					});
				});
		});
	}

	resetTable = (isSearching = false) => {
		this.setState((state) => ({
			data: [],
			isLoading: false,
			isDisabled: isSearching,
			isSearching,
			pagination : { 
				...state.pagination, 
				current: 1, 
				total  : 0 
			} 
		}));
	}

	handleGetColumnsList = (data, contrato, paginate, totais) => {
		columnsService.show({ empresa_id: this.state.empresa_id || contrato?.empresa_id })
			.then((response) => {
				this.setState({
					columnsList: response.data.data[0],
				}, async () => {
					this.getJoinColumns(paginate);
					this.getDynamicColumns();
					this.getOvertimeColumns();
					this.handleGetTotalTimeCard(totais, () => this.setState({ isLoading: false }));
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	handleGetTotalTimeCard = (dataTotal, callback) => {
		this.setState({
			dataTotal: {
				...dataTotal,
				_total_ajustado: this.formatTime(dataTotal?.total_ajustado),
			}
		}, callback);
	}

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll(true);
		});
	};

	formatTime = (time) => {
		if (time < 0) {
			return `-${moment().startOf("day").add(Math.abs(time), "minutes").format("HH:mm")}`;
		}

		return moment().startOf("day").add(time, "minutes").format("HH:mm");
	}

	checkBatidas = (item) => {
		const batidas = item.cartaopontobatida;
		for (let i = 0; i < batidas.length; i++) {
			const batida = batidas[i];

			if (batida.entrada_batida !== null && batida.entrada_batida !== "00:00") {
				return true;
			}

			if (batida.saida_batida !== null && batida.saida_batida !== "00:00") {
				return true;
			}
		}

		return false;
	}

	columnsOpen = () => {
		const empresa_id = this.state.data[0]?.contrato?.empresa_id || this.form.getFieldValue("empresa_id") || 0;

		if (!isNaN(empresa_id) && empresa_id > 0) {
			this.setState({columnsModalVisible: true});

			// On open screen
			this.columnsScreen.onOpen(empresa_id);
		} else {
			Modal.error({
				title: "Ocorreu um erro!",
				content: "Selecione uma empresa para gerenciar as colunas.",
			});
		}
	};

	columnsOnClose = () => {
		this.setState({columnsModalVisible: false});
	}

	columnsOnComplete = () => this.setState({ columnsModalVisible: false }, () => this.form.submit());

	journeyOpen = (journeyId) => {
		if (journeyId) {
			this.setState({ journeyShowModalVisible: true });

			// On open screen
			this.journeyShowScreen.onOpen(journeyId);
		} else {
			Modal.warning({
				title: "Ação Necessária!",
				content: "Identifique um funcionário na seleção 'Funcionário' para obter os detalhes da jornada.",
			});
		}
	}

	journeyOnClose = () => {
		this.setState({journeyShowModalVisible: false});

		document.querySelector(".ant-modal-wrap").focus();
	};

	ajustesOpen = (item) => {
		this.setState({ ajustesModalVisible: true });

		// On open screen
		this.ajustesScreen.onOpen(item);
	};

	ajustesOnClose = () => {
		this.setState({ ajustesModalVisible: false });
	}

	ajustesOnComplete = (item) => {
		this.setState({ ajustesModalVisible: false });
		this.updateRow(item);
	}

	bancoAjustesOpen = (item) => {
		this.setState( { bancoAjustesModalVisible: true });

		// On open screen
		this.bancoAjustesScreen.onOpen(item);
	};

	bancoAjustesOnClose = () => {
		this.setState({ bancoAjustesModalVisible: false });
	}

	bancoAjustesOnComplete = (item) => {
		this.setState({ bancoAjustesModalVisible: false });
		this.updateRow();
	}

	updateRow = (item) => {
		if (!item) return this.fetchGetAll(true);

		//TODO consultar apenas os 3 dias estava gerando desencontro de totais
		if (true || !item.contrato.nao_usa_banco_horas || item.status === 'justificativa_parcial' || item.usa_banco_horas) return this.fetchGetAll(true);

		const base = moment(item.data);
		const initial = base.clone().subtract(1, 'day').format('YYYY-MM-DD');
		const final = item?.jornada?.dsr_id
			? base.clone().endOf('week').add(1, 'day').format('YYYY-MM-DD')
			: base.clone().add(1, 'day').format('YYYY-MM-DD');


		this.fetchGetItems(true, initial, final, false, 1);
	}

	sendToSignOpen = () => {
		this.setState( { modalSendToSignVisible: true });
	};

	signedCardsOpen = () => {
		this.setState( { modalSignedCardsVisible: true });
	};


	sendToSignClose = () => {
		this.setState( { modalSendToSignVisible: false });
	}

	signedCardsClose = () => {
		this.setState( { modalSignedCardsVisible: false });
	}


	printOpen = () => {
		const { filters } = this.state;

		const empresa_id      = this.state.empresa_id;
		const departamento_id = filters.departamento_id;
		const jornada_id      = filters.jornada_id;
		const funcao_id       = filters.funcao_id;
		const status          = filters.status;
		const datainicial     = this.form.getFieldValue("datainicial");
		const datafinal       = this.form.getFieldValue("datafinal");
		const funcionario_id  = this.form.getFieldValue("funcionario_id");

		let params = {};

		if (empresa_id) {
			params.empresa_id = empresa_id;
		}

		if (departamento_id) {
			params.departamento_id = departamento_id;
		}

		if (datainicial) {
			params.datainicial = moment(datainicial).format("YYYY-MM-DD");
		}

		if (datafinal) {
			params.datafinal = moment(datafinal).format("YYYY-MM-DD");
		}

		if (status) {
			params.status = status;
		}

		if (jornada_id) {
			params.jornada_id = jornada_id;
		}

		if (funcao_id) {
			params.funcao_id = funcao_id;
		}

		if (funcionario_id) {
			params.funcionario_id = funcionario_id;
		}

		if (this.columns().length > 27) {
			Modal.info({
				title: 'Limite de colunas excedido!',
				content: (
					<div style={{ textAlign: 'justify' }}>
						O número de colunas de impressão ultrapassou o limite de 26, o que pode comprometer a formatação e a qualidade da impressão. Por favor, ajuste as colunas antes de prosseguir.
					</div>
				),
				maskClosable: false,
				keyboard: false,
				closable: false,
				onOk: () => {
					window.close();
				},
			})
			return;
		}
		window.open(`/impressao/timecard?${qs.stringify(params)}`, '_blank');		
	}

	reloadRow = () => {
		this.form.submit();
	}

	onEditEntradaSaida = (itemId, itemIndex, batidaIndex, sequence, type) => {
		this.editScreen.onOpen(this.state.data[itemIndex], itemIndex, batidaIndex, sequence, type, this.state.maxJoinColumns);
	}

	onChangeEntradaSaida = (value, itemId, itemIndex, batidaIndex, sequence, type, initialValue, deletePressed) => {
		let isEditing = false;
		const batida = this.state.data[itemIndex].cartaopontobatida[batidaIndex];
		let isBatidaOriginal = (type === 'entrada' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_registro_entrada_id && !this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada_id) ||
			(type === 'saida' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_registro_saida_id && !this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida_id) ||
			(type === 'entrada' && batida?.ponto_ajuste_entrada?.tipo === 'Original' && batida?.ponto_ajuste_entrada?.ponto_registros_id) ||
			(type === 'saida' && batida?.ponto_ajuste_saida?.tipo === 'Original' && batida?.ponto_ajuste_saida?.ponto_registros_id);

		// Se tem a batida escolhida
		if( batidaIndex !== -1 )
		{
			if( !deletePressed && type === 'entrada' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada_id && !!this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.entrada_batida )
			{
				isEditing = true;
			}
			else if( !deletePressed && type === 'saida' && this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida_id && !!this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.saida_batida )
			{
				isEditing = true;
			} else {
				if(deletePressed && !isBatidaOriginal) {
					this.setState({
						isLoading: true,
					});

					// Descarta batida direto
					this.discardScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo, initialValue, deletePressed, true);

					return false;
				}
				if(deletePressed || isBatidaOriginal) {
					this.discardScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo, initialValue, deletePressed);

					return false;
				}
			}
		}

		if( !isEditing )
		{
			this.createScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo);

			return false;
		}

		this.setState({
			isLoading: true,
		});

		const data = {
			cartao_ponto_batida_id: this.state.data[itemIndex].cartaopontobatida[batidaIndex].id,
			sequencia             : sequence,
		};

		if( type === 'entrada' )
		{
			data.hora_entrada = value.length ? `${moment(this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada.data || this.state.data[itemIndex].data).format("YYYY-MM-DD")} ${value}:00` : '';
			data.motivo_entrada = value.length ? this.state.data[itemIndex].cartaopontobatida[batidaIndex].ponto_ajuste_entrada.motivo : null;
			// if( this.state.data[itemIndex].cartaopontobatida[batidaIndex].saida_batida )
			// {
			// 	data.hora_saida = `${this.state.data[itemIndex].data} ${this.state.data[itemIndex].cartaopontobatida[batidaIndex].saida_batida}:00`;
			// }
		}
		else
		{
			data.hora_saida = value.length ? `${moment(this.state.data[itemIndex].cartaopontobatida[batidaIndex]?.ponto_ajuste_saida.data || this.state.data[itemIndex].data).format("YYYY-MM-DD")} ${value}:00` : '';
			data.motivo_saida = value.length ? this.state.data[itemIndex].cartaopontobatida[batidaIndex].ponto_ajuste_saida.motivo : null;
			// if( this.state.data[itemIndex].cartaopontobatida[batidaIndex].entrada_batida )
			// {
			// 	data.hora_entrada = `${this.state.data[itemIndex].data} ${this.state.data[itemIndex].cartaopontobatida[batidaIndex].entrada_batida}:00`;
			// }
		}

		timeCardService.batidaHorarioEdit(data).then((response) => {
			this.setState({
				isLoading: false,
			});

			this.updateRow(response.data.data[0]);

			//this.reloadRow(this.state.data[itemIndex].id);
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				isLoading: false,
			});

			// Reset input
			floatbox.resetInput(itemId, itemIndex, sequence, type);

			Modal.error({
				title   : "Ocorreu um erro!",
				content : String(data),
				centered: true,
			});
		});
	}

	createOnComplete = (itemId, itemIndex, sequence, type, row, motivo) => {
		//TODO buscar apenas 3 dias estava gerando desencontros com os totais, verificar uma melhor forma de otimizar
		if (!row || row?.usa_banco_horas || true) {
			this.fetchGetAll(true);
		} else {
			const base = moment(row.data);
			const initial = base.clone().subtract(1, 'day').format('YYYY-MM-DD');
			const final = row?.jornada?.dsr_id
        ? base.clone().endOf('week').add(1, 'day').format('YYYY-MM-DD')
        : base.clone().add(1, 'day').format('YYYY-MM-DD');
	
			this.fetchGetItems(true, initial, final, false, 1);
		}

		const { joinColumns } = this.state;
		joinColumns.filter((item) => item.index === sequence).map((item) => {
			item.original = true;
		});

		this.setState({
			motivo,
		});
	}

	editOnComplete = (itemId, itemIndex) => {
		this.fetchGetAll(true);
	}

	discardOnComplete = (itemId, itemIndex, sequence, type, motivo, value, batidaIndex, deletePressed) => {
		this.setState({
			isLoading: false,
		});

		this.updateRow(this.state.data[itemIndex]);

		this.setState({
			motivo,
		}, () => {
			if (deletePressed) return false;
			this.createScreen.onOpen(this.state.data[itemIndex], value, itemIndex, batidaIndex, sequence, type, this.state.motivo);
		});
	}

	/**
 	* Filter
	*/
	filtersOpen = () => {
		this.setState({ filtersModalVisible: true });

		// On open screen
		this.filtersScreen.onOpen({ ...this.state.filters });
	};

	filtersOnClose = () => {
		this.setState({ filtersModalVisible: false });
	};

	filtersOnComplete = (filters) => {
		this.setState({ filtersModalVisible: false }, () => {
			this.setState({
				filters,
			}, () => {
				this.fetchEmployees('0', true, this.loadFirstEmployee);
				this.fetchGetAll(true);
			});
		});
	};

	formatBatidaStatus = (item, batida) => {
		// Status individuais
		if (batida) {
			if(batida?.ponto_ajustes_justificativa_falta_id && !item?.feriado_id) {
				return batida?.ponto_ajustes_justificativa_falta?.justificativa?.nome ?? "Justificativa";
			}
		}

		if (item?.afastamento?.justificativa_id && !item?.feriado_id) {
			return item?.afastamento?.justificativa?.nome ?? "Justificativa";
		}

		if (item.possui_batidas) {
			return null;
		}

		// Status de dia todo
		if (item?.feriado_id) {
			return "Feriado";
		}

		if (item?.pontoajuste?.justificativa_id) {
			return item?.pontoajuste?.justificativa?.nome ?? "Justificativa";
		}  

		if (item?.folga) {
			return "Folga";
		} 
		
		if (item?.feriado_id && item?.afastamento_id) {
			return item?.afastamento?.justificativa?.nome;
		}
		
		if (item?.dia_especial) {
			return "";
		}  
		
		if (item.status === "dia_sem_jornada") {
			return "";
		}

		if (item?.status === "falta") {
			return "Falta";
		}

		return null;
	}

	formatBatidaCanEdit = (item) => {
		if (item.status === 'afastamento') {
			return false;
		}

		if (item.contrato.arquivar === 1) {
			return false;
		}

		return true;
	}

	onGoToEntradaSaida = (to, itemId, itemIndex, batidaIndex, sequence, type) => {
		this.setState({
			isLoading: true,
		});

		const row     = this.state.data[itemIndex];
		const batida  = row.cartaopontobatida[batidaIndex];
		const dataDia = row.data;

		const data = {
			cartao_ponto_id       : row.id,
			cartao_ponto_batida_id: batida.id,
			sequencia             : sequence,
			to                    : to,
			type                  : type,
		};

		if( batida.entrada_batida )
		{
			data.entrada_batida = `${dataDia} ${batida.entrada_batida}:00`;
		}

		if( batida.saida_batida )
		{
			data.saida_batida = `${dataDia} ${batida.saida_batida}:00`;
		}

		if( batida.ponto_ajuste_entrada_id )
		{
			data.ponto_ajuste_entrada_id = batida.ponto_ajuste_entrada_id;
		}

		if( batida.ponto_ajuste_saida_id )
		{
			data.ponto_ajuste_saida_id = batida.ponto_ajuste_saida_id;
		}

		timeCardService.movimentarBatida(data).then((response) => {
			this.setState({
				isLoading: false,
			});

			this.updateRow(response.data.data[0]);

			//this.reloadRow(this.state.data[itemIndex].id);
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			this.setState({
				isLoading: false,
			});

			// Reset input
			floatbox.resetInput(itemId, itemIndex, sequence, type);

			Modal.error({
				title   : "Ocorreu um erro!",
				content : String(data),
				centered: true,
			});
		});
	}

	hasJustificationRequest = (date, id) => {
		const { justificationRequests, pontoAjusteRequests } = this.state;

		const hasPontoAjusteRequest = Array.isArray(pontoAjusteRequests) 
			&& pontoAjusteRequests.some(item => item.cartao_ponto_id === id);

		const hasJustificationRequests = Array.isArray(justificationRequests) 
			&& justificationRequests.some(item => moment.utc(item.data).format('YYYY-MM-DD') === date);

		return hasPontoAjusteRequest || hasJustificationRequests;
	}

	getInitialValueInputOutput = (status, batida, fieldName, rowIndex) => {
		const { data } = this.state;

    const rowData = data[rowIndex];
    const isHoliday = rowData.status === 'feriado';
    const hasBatidas = rowData.cartaopontobatida.length > 0;

    if (batida?.[fieldName]) {
			return batida[fieldName];
    }

    if (status) {
			return status;
    }

    if (isHoliday && !hasBatidas) {
			return rowData.status_nome;
    }

    return "";
	};

	getJoinColumns = (pagination) => {
		const {data, maxJoinColumns} = this.state;

		let columns = [];
		let max = 0;

		data.forEach((item) => {
			let totalBatidasJornada = item.jornadadiasemana?.jornada_batidas?.length ?? 0;
			let totalBatidasCartao  = item.cartaopontobatida?.length ?? 0;

			if(totalBatidasJornada) {
				// Pega a sequencia do ultima batida, api ja retorna por sequencia asc
				const maxJornada = item.jornadadiasemana.jornada_batidas[totalBatidasJornada - 1].sequencia;

				if( maxJornada > max )
				{
					max = maxJornada;
				}
			}

			if( totalBatidasCartao )
			{
				// Pega a sequencia do ultima batida, api ja retorna por sequencia asc
				const maxBatida = item.cartaopontobatida[totalBatidasCartao - 1].sequencia;

				if( maxBatida > max )
				{
					max = maxBatida;
				}
			}

			if (item?.jornada?.tipo_calculo === 'horista' && max === 0) {
				max = 3;
			}
		});

		if (pagination) {
			max = Math.max(max, maxJoinColumns);
		}

		this.setState({
			maxJoinColumns: max,
		});

		[...Array(max).keys()].map((index) => {
			columns.push(
				{
					tag: 'Entrada ' + (index + 1),
					title: 'Ent. ' + (index + 1),
					index: index + 1,
					group: groups.punches,
					width: CELL_WIDTH,
					className: "punch",
					original: true,
					render: (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit = this.formatBatidaCanEdit(item);

						let isManualPunchResult = false;

						const isManualPunch = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							return isManualPunchResult = batidaIndex !== -1 && (item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada?.tipo === 'inclusao');
						};

						const isPreMarked = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							if (isManualPunchResult || item?.cartaopontobatida[batidaIndex]?.ponto_registro_entrada?.tipo === 'Original') return false;

							return batidaIndex !== -1 && item.status !== 'dia_sem_jornada' &&
								(item.cartaopontobatida[batidaIndex].entrada_auto_jornada === 1 && item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_entrada?.tipo === 'Pré-assinalado');
						};

						const isInterjornadaDeb = (item) => {
							const hasDebit = item.interjornada_debito && item.interjornada_debito !== '00:00'
							if (item.interjornada_debito_batida_tipo || hasDebit) {
								const maiorSequenciaValida = item.cartaopontobatida.reduce((acc, current, index) => {
									if (!current.entrada_batida && !current.saida_batida) {
										return acc;
									}

									if (!acc) {
										return { ...current, index };
									}

									if (current.sequencia > acc.sequencia) {
										return { ...current, index };
									}

									return acc;
								}, null);

								const menorSequenciaValida = item.cartaopontobatida.reduce((acc, current, index) => {
									if (!current.entrada_batida && !current.saida_batida) {
										return acc;
									}

									if (!acc) {
										return { ...current, index };
									}

									if (current.sequencia < acc.sequencia) {
										return { ...current, index };
									}

									return acc;
								}, null);

								const maiorBatidaIndex = maiorSequenciaValida?.index ?? -1;
								const menorBatidaIndex = menorSequenciaValida?.index ?? -1;
								const maiorBatida = item.cartaopontobatida[maiorBatidaIndex];
								const menorBatida = item.cartaopontobatida[menorBatidaIndex];

								if (maiorBatidaIndex > -1 && maiorBatida.sequencia === index + 1){
									return (item.cartaopontobatida[maiorBatidaIndex].entrada_batida && !item.cartaopontobatida[maiorBatidaIndex].saida_batida && item.interjornada_debito_batida_tipo) ||
										(item.cartaopontobatida[menorBatidaIndex].entrada_batida && hasDebit && maiorBatidaIndex === menorBatidaIndex);
								}

								if (menorBatidaIndex > -1 && menorBatida.sequencia === index + 1) {
									return item.cartaopontobatida[menorBatidaIndex].entrada_batida && hasDebit;
								}

								return false;
							}
						}
						
						const initialValue = this.getInitialValueInputOutput(status, item.cartaopontobatida[batidaIndex], 'entrada_batida', row_index)
						const fora_perimetro = item.cartaopontobatida?.[batidaIndex]?.ponto_registro_entrada?.fora_perimetro
							?? item.cartaopontobatida?.[batidaIndex]?.ponto_ajuste_entrada?.pontoRegistro?.fora_perimetro;

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									isManualPunch={isManualPunch(item, index)}
									isPreMarked={isPreMarked(item, index)}
									isInterjornadaDeb={isInterjornadaDeb(item, index)}
									fora_perimetro={fora_perimetro}
									status={item.status}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="entrada"
									canGoToLeft={batidaIndex !== -1 && index > 0}
									canGoToRight={batidaIndex !== -1}
									initialValue={initialValue}
								/>
							</div>
						)
					}
				},
				{
					tag: 'Saída ' + (index + 1),
					title: 'Saí. ' + (index + 1),
					index: index + 1,
					group: groups.punches,
					width: CELL_WIDTH,
					className: "punch",
					original: true,
					render: (item, row_index) => {
						const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
						const status = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
						const canEdit = this.formatBatidaCanEdit(item);

						let isManualPunchResult = false;

						const isManualPunch = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							return isManualPunchResult = batidaIndex !== -1 && (item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_saida?.tipo === 'inclusao');
						};

						const isPreMarked = (item, index) => {
							const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
							if (isManualPunchResult || item?.cartaopontobatida[batidaIndex]?.ponto_registro_saida?.tipo === 'Original') return false;

							return batidaIndex !== -1 && item.status !== 'dia_sem_jornada' &&
								(item.cartaopontobatida[batidaIndex].saida_auto_jornada === 1 && item?.cartaopontobatida[batidaIndex]?.ponto_ajuste_saida?.tipo === 'Pré-assinalado');
						};

						const isInterjornadaDeb = (item) => {
							const hasDebit = item.interjornada_debito && item.interjornada_debito !== '00:00'
							if (item.interjornada_debito_batida_tipo || hasDebit) {
								const maiorSequenciaValida = item.cartaopontobatida.reduce((acc, current, index) => {
									if (!current.entrada_batida && !current.saida_batida) {
										return acc;
									}

									if (!acc) {
										return { ...current, index };
									}

									if (current.sequencia > acc.sequencia) {
										return { ...current, index };
									}

									return acc;
								}, null);

								const menorSequenciaValida = item.cartaopontobatida.reduce((acc, current, index) => {
									if (!current.entrada_batida && !current.saida_batida) {
										return acc;
									}

									if (!acc) {
										return { ...current, index };
									}

									if (current.sequencia < acc.sequencia) {
										return { ...current, index };
									}

									return acc;
								}, null);

								const maiorBatidaIndex = maiorSequenciaValida?.index ?? -1;
								const menorBatidaIndex = menorSequenciaValida?.index ?? -1;
								const maiorBatida = item.cartaopontobatida[maiorBatidaIndex];
								const menorBatida = item.cartaopontobatida[menorBatidaIndex];

								if (maiorBatidaIndex > -1 && maiorBatida.sequencia === index + 1){
									return (item.cartaopontobatida[maiorBatidaIndex].saida_batida && item.interjornada_debito_batida_tipo) || 
									(!item.cartaopontobatida[maiorBatidaIndex].entrada_batida && item.cartaopontobatida[maiorBatidaIndex].saida_batida && hasDebit);
								}

								if (menorBatidaIndex > -1 && menorBatida.sequencia === index + 1) {
									return (item.cartaopontobatida[menorBatidaIndex].saida_batida && !item.cartaopontobatida[menorBatidaIndex].entrada_batida && hasDebit) || 
									(item.cartaopontobatida[menorBatidaIndex].saida_batida && item.interjornada_debito_batida_tipo && menorBatidaIndex === maiorBatidaIndex);
								}

								return false;
							}
						}

						const initialValue = this.getInitialValueInputOutput(status, item.cartaopontobatida[batidaIndex], 'saida_batida', row_index)
						const fora_perimetro = item.cartaopontobatida?.[batidaIndex]?.ponto_registro_saida?.fora_perimetro
							?? item.cartaopontobatida?.[batidaIndex]?.ponto_ajuste_saida?.pontoRegistro?.fora_perimetro;

						return !this.state.isLoading && (
							<div>
								<FloatBox
									canEdit={canEdit}
									onEdit={this.onEditEntradaSaida}
									onChange={this.onChangeEntradaSaida}
									onGoTo={this.onGoToEntradaSaida}
									isManualPunch={isManualPunch(item, index)}
									isPreMarked={isPreMarked(item, index)}
									isInterjornadaDeb={isInterjornadaDeb(item, index)}
									fora_perimetro={fora_perimetro}
									status={item.status}
									itemId={item.id}
									itemIndex={row_index}
									indexBatida={batidaIndex}
									sequence={index + 1}
									type="saida"
									canGoToLeft={batidaIndex !== -1}
									canGoToRight={batidaIndex !== -1 && index + 1 < max}
									initialValue={initialValue}
								/>
							</div>
						)
					}
				}
			);
		});

		this.setState({
			joinColumns: columns,
		});
	}

	getDynamicColumns = () => {
		const { columnsList } = this.state;
		let columns = [];

		const column = (title, render, total) => ({
			title,
			group    : groups.results,
			width    : CELL_WIDTH,
			className: "text-center",
			render,
			total    : () => <div>{total(this.state.dataTotal)}</div>,
		});

		const hours = (value) => value === "00:00" ? "" : value;

		if (columnsList?.apuracao_normal) {
			columns.push(column('Normal', (item) => <div>{hours(item.horas_normal)}</div>, (total) => total.total_horas_normais || ""));
		}

		if (columnsList?.apuracao_faltas) {
			columns.push(column('Faltas', (item) => <div>{hours(item.horas_falta)}</div>, (total) => total.total_horas_faltas || ""));
		}

		if (columnsList?.apuracao_carga) {
			columns.push(column('Carga', (item) => <div>{hours(item.carga_horaria_jornada)}</div>, (total) => total.total_horas_carga || ""));
		}

		if (columnsList?.apuracao_atraso) {
			columns.push(column('Atraso', (item) => <div>{hours(item.horas_atraso)}</div>, (total) => total.total_horas_atraso || ""));
		}

		if (columnsList?.apuracao_falta_dia) {
			columns.push(column(<div className="flexColumnCustom">Falta<br />Dia</div>, (item) => <div>{item.falta_dia_inteiro || ""}</div>, (total) => total.total_falta_dia));
		}

		if (columnsList?.apuracao_ajuste) {
			columns.push(column('Ajuste', (item) => (
				<div className="time-card-grid-link" onClick={() => this.ajustesOpen(item)}>{hours(item._ajuste_horas_falta)}</div>
			), (total) => total.total_ajustado));
		}

		if (columnsList?.apuracao_dsr) {
			columns.push(column('Dsr', (item) => <div>{hours(item.dsr_valor)}</div>, (total) => total.total_dsr || ""));
		}

		if (columnsList?.apuracao_dsr_debito) {
			columns.push(column(<div className="flexColumnCustom">Dsr<br />Déb.</div>, (item) => <div>{hours(item.dsr_debito)}</div>, (total) => total.total_dsr_debito || ""));
		}

		if (columnsList?.apuracao_dsr_debito_dia) {
			columns.push(column(<div className="flexColumnCustom">Dsr<br />Déb. Dia</div>, (item) => <div>{item.dsr_debito_dia || ""}</div>, (total) => total.total_dsr_debito_dia));
		}

		if (columnsList?.apuracao_adiconal_noturno) {
			columns.push(column(<div className="flexColumnCustom">Adic.<br />Noturno</div>, (item) => <div>{hours(item.adicional_noturno)}</div>, (total) => total.total_adiconal_noturo || ""));
		}

		if (columnsList?.apuracao_abono) {
			columns.push(column('Abono', (item) => <div>{hours(item.horas_abono)}</div>, (total) => total.total_abono || ""));
		}

		if (columnsList?.apuracao_interjornada) {
			columns.push(column('Interj.', (item) => <div>{hours(item.interjornada_debito)}</div>, (total) => total.total_interjornada_debito));
		}

		if (columnsList?.apuracao_extra) {
			columns.push(column('Extra', (item) => <div>{hours(item.horas_extra)}</div>, (total) => total.total_horas_extras || ""));
		}

		this.setState({
			dynamicColumns: columns,
		});
	}

	overtimeTotal = (idsFaixa) => {
		const totals = this.state.dataTotal?.horas_extras ?? {};
		const key    = Object.keys(totals).find((id) => idsFaixa.includes(parseInt(id)));

		return key ? totals[key] : "00:00";
	}

	bankTotal = (key) => {
		const value = this.state.dataTotal?.[key] || "";

		return (
			<div className={value.startsWith('-') ? 'colorBDeb' : 'colorBCred'}>
				{value}
			</div>
		);
	}

	getOvertimeColumns = () => {
		const { data, columnsList } = this.state;
		let columns = [];

		const filteredDataUsaBancoHoras = data.filter(item => item.usa_banco_horas === 1);

		// hora_extra_diurna
		// hora_extra_intervalo
		// hora_extra_noturna

		data.forEach((item) => {
			(item.hora_extra?.hora_extra_dados ?? []).forEach((dados) => {

				dados.hora_extra_faixas.forEach((faixa) => {
					const index = columns.findIndex((column) => column.percentual === faixa.percentual && column.periodo === dados.periodo);

					if( index === -1 )
					{
						if( (columnsList?.hora_extra_diurna && dados.periodo === "diurno") || (columnsList?.hora_extra_intervalo && dados.periodo === "intervalo") || (columnsList?.hora_extra_noturna && dados.periodo === "noturno") )
						{
							columns.push(
								{
									idsFaixa  : [faixa.id],
									percentual: faixa.percentual,
									periodo   : dados.periodo,
									title     : `${parseFloat(faixa.percentual)}%`,
									group     : groups.overtime,
									subgroup  : overtimePeriods[overtimePeriodIndex(dados.periodo)]?.label,
									width     : CELL_WIDTH,
									className : "text-center",
								},
							);
						}
					}
					else
					{
						columns[index].idsFaixa.push(faixa.id);
					}
				});
			});
		});

		columns.forEach((column) => {
			column.render = (item) => {
				let value = "";
				item.cartaopontohorasextras.forEach((extra) => {
					if( column.idsFaixa.includes(extra.horas_extras_faixa_id) )
					{
						value = extra.quantidade;
						return false;
					}
				});

				return (
					<div>{value}</div>
				)
			};
			column.total = () => <div>{this.overtimeTotal(column.idsFaixa)}</div>;
		});

		columns.sort((a, b) => overtimePeriodIndex(a.periodo) - overtimePeriodIndex(b.periodo));

		if( columnsList?.banco_hora && filteredDataUsaBancoHoras.length > 0 )
		{
			columns.push({
				title    : 'BCréd',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_extras'),
				className: "text-center colorBCred",
				render: (item) => <div>{item.horas_banco_extras === "00:00" ? "" : item.horas_banco_extras}</div>
			});

			columns.push({
				title    : 'BDéb',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_falta'),
				className: "text-center colorBDeb",
				render: (item) => <div>{item.horas_banco_falta === "00:00" ? "" : item.horas_banco_falta}</div>
			});

			columns.push({
				title: 'BTotal',
				group: groups.bank,
				width: CELL_WIDTH,
				total: () => this.bankTotal('bh_horas_total'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_total?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div className={`${colorClass}`}>
							{item.horas_banco_total === "00:00" ? "" : item.horas_banco_total}
						</div>
					);
				}
			});

			columns.push({
				title    : 'BSaldo',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_saldo'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_saldo?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div className={`${colorClass}`}>
							{item.horas_banco_saldo === "00:00" ? "00:00" : item.horas_banco_saldo}
						</div>
					);
				}
			});

			columns.push({
				title    : 'BAjuste',
				group    : groups.bank,
				width    : CELL_WIDTH,
				total    : () => this.bankTotal('bh_horas_ajuste'),
				className: "text-center",
				render: (item) => {
					const isNegative = item.horas_banco_ajustes?.startsWith('-');
					const colorClass = isNegative ? "colorBDeb" : "colorBCred";
					return (
						<div
							className={`time-card-grid-link ${colorClass}`}
							onClick={() => this.bancoAjustesOpen(item)}
						>
							<div>{item.horas_banco_ajustes === "00:00" ? "" : item.horas_banco_ajustes}</div>
						</div>
					);
				}
			});
		}

		this.setState({
			overtimeColumns: columns,
		});
	}

	columns = () => {
		return [
			{
				title    : 'Dia',
				width    : 170,
				className: "day",
				render   : (item, row_index, row) => {
					const status      = icones_status[item?.status];
					const archived    = item?.contrato?.arquivar === 1;
					const pending     = this.hasJustificationRequest(item?.data, item?.id);
					const statusTitle = this.getStatusTitle(item);

					return (
						<div className={`time-card-day ${pending ? "is-pending" : ""}`}>
							<span className="time-card-day-date">{moment(item?.data).format("DD/MM")}</span>
							<span className="time-card-day-weekday">{moment(item?.data).format("ddd")}</span>
							{pending && (
								<Tooltip title="Justificativa e/ou marcação manual pendente de aprovação">
									<i className="fas fa-clock time-card-day-pending" />
								</Tooltip>
							)}
							<Tooltip title={archived ? `${statusTitle} · Dia referente a contrato arquivado e não poderá ser editado!` : statusTitle}>
								<span className="time-card-day-status-wrap">
									<button type="button" className="time-card-day-status" disabled={archived} onClick={row?.openActions}>
										{status && <i className={`fas ${status.icon}`} style={{ color: item?.status_cor }} />}
										<i className="far fa-chevron-down time-card-day-chevron" />
									</button>
								</span>
							</Tooltip>
						</div>
					);
				}
			},
			{
				title: 'Previsto',
				width: 110,
				className: "previsto",
				render: (item) => {
					const hasThirdJourney = item?.jornadadiasemana?.jornada_batidas[2]?.entrada;
					const journeyList = item?.jornadadiasemana?.jornada_batidas;
					let journeyListToShow = [];

					if (hasThirdJourney) {
						const [firstJourney, secondJourney] = journeyList;
						journeyListToShow = [firstJourney, secondJourney];
					} else if (journeyList?.length > 0) {
						journeyListToShow = journeyList;
					}

					const journeyRender = (lista, isTooltip) => {
            return (
              <div>
                {lista.map((batida, index) => {
                  if (!batida.entrada || !batida.saida) {
                    return null;
                  }

                  const shouldDisplay =
                    !item?.folga && !item?.feriado_id && !item?.dia_especial;

                  return (
                    <Fragment key={index}>
                      <span
                        style={{ display: shouldDisplay ? "inline" : "none" }}
                      >
                        {batida.entrada} - {batida.saida}
                      </span>
                      <br />
                    </Fragment>
                  );
                })}
                {hasThirdJourney && !isTooltip && (
                  <div className="overflow_journey_indicator">...</div>
                )}
              </div>
            );
          };

					return (
            <div className="inner">
              <Tooltip
                title={
                  hasThirdJourney
                    ? journeyRender(journeyList, true)
                    : ""
                }
              >
                {journeyRender(journeyListToShow)}
              </Tooltip>
            </div>
          );
				}
			},
			...this.state.joinColumns,
			// {
			// 	title      : null,
			// 	titleRender: <Button type="primary" shape="circle" icon={<i className="far fa-plus" />} onClick={this.newJoinColumn}></Button>,
			// 	className  : "last-column",
			// 	width      : 40,
			// 	render     : () => <Fragment></Fragment>
			// },
			...this.state.dynamicColumns,
			...this.state.overtimeColumns,
		]
	}

	getStatusTitle = (row) => {
		if (row?.status_nome === 'Dia sem jornada') {
			return 'Dia sem horário'
		}

		return row?.status_nome ?? ""
	}

	newJoinColumn = () => {
		const { isSearching, joinColumns } = this.state;
		let index = joinColumns.length / 2;

		if (!isSearching) this.fetchGetAll(true);

		joinColumns.push(
			{
				tag: 'Entrada ' + (index + 1),
				title: 'Ent. ' + (index + 1),
				index: index + 1,
				group: groups.punches,
				width: CELL_WIDTH,
				className: "punch",
				original: false,
				render: (item, row_index) => {
					const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
					const status = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
					const canEdit = this.formatBatidaCanEdit(item);

					return !this.state.isLoading && (
						<div>
							<FloatBox
								canEdit={canEdit}
								onEdit={this.onEditEntradaSaida}
								onChange={this.onChangeEntradaSaida}
								onGoTo={this.onGoToEntradaSaida}
								itemId={item.id}
								itemIndex={row_index}
								indexBatida={batidaIndex}
								sequence={index + 1}
								type="entrada"
								canGoToLeft={batidaIndex !== -1 && index > 0}
								canGoToRight={batidaIndex !== -1}
								initialValue={status ?? item.cartaopontobatida[batidaIndex]?.entrada_batida ?? ""}
							/>
						</div>
					)
				}
			},
			{
				tag: 'Saída ' + (index + 1),
				title: 'Saí. ' + (index + 1),
				index: index + 1,
				group: groups.punches,
				width: CELL_WIDTH,
				className: "punch",
				original: false,
				render: (item, row_index) => {
					const batidaIndex = item.cartaopontobatida.findIndex(batida => batida.sequencia === index + 1);
					const status = this.formatBatidaStatus(item, batidaIndex === -1 ? null : item.cartaopontobatida[batidaIndex]);
					const canEdit = this.formatBatidaCanEdit(item);

					return !this.state.isLoading && (
						<div>
							<FloatBox
								canEdit={canEdit}
								onEdit={this.onEditEntradaSaida}
								onChange={this.onChangeEntradaSaida}
								onGoTo={this.onGoToEntradaSaida}
								itemId={item.id}
								itemIndex={row_index}
								indexBatida={batidaIndex}
								sequence={index + 1}
								type="saida"
								canGoToLeft={batidaIndex !== -1}
								canGoToRight={batidaIndex !== -1 && index + 1 < this.state.maxJoinColumns}
								initialValue={status ?? item.cartaopontobatida[batidaIndex]?.saida_batida ?? ""}
							/>
						</div>
					)
				}
			}
		);

		this.setState({
			joinColumns,
			maxJoinColumns: this.state.maxJoinColumns + 1,
		});
	}

	removeBatida = () => {
		const {joinColumns} = this.state;

		if( joinColumns.length > 2 && !joinColumns[joinColumns.length - 1].original )
		{
			joinColumns.pop();
			joinColumns.pop();

			this.setState({
				joinColumns,
				maxJoinColumns: this.state.maxJoinColumns - 1,
			});
		} else {
			message.warning("Não é possível remover colunas originais!");
		}
	}

	onFinish = (values) => {
		const { filters } = this.state;

		this.setState({
			departamento_id: filters.departamento_id,
			funcao_id      : filters.funcao_id,
			jornada_id     : filters.jornada_id,
			status         : filters.status,
			empresa_id     : values.empresa_id,
			dataInicial    : values.datainicial.format("YYYY-MM-DD"),
			dataFinal      : values.datafinal.format("YYYY-MM-DD"),
		}, () => {
			this.selectEmployee(values.funcionario_id);
		});
	};

	goTo = async (currentEmployeeId) => {
		const { employees } = this.state;

		const currentIndex = employees.findIndex((employee) => employee.id === currentEmployeeId);
		const len = employees.length - 1;
		if (currentIndex < 0 || currentIndex > len) return;
	
		const nextEmployeeId = employees[currentIndex + 1]?.id;
		if (!nextEmployeeId) return;

		this.selectEmployee(nextEmployeeId, true);
	}

	/**
 	 * Avança para o próximo funcionário na lista de funcionários.
 	 */
	goToNextEmployee = async () => {
		const { employees, employeeData } = this.state;
		const page = parseInt(employeeData?.page || 1);
		const pages = parseInt(employeeData?.pages || 1);

		const currentEmployeeId = this.form.getFieldValue("funcionario_id");
		const currentIndex = employees.findIndex((employee) => employee.id === currentEmployeeId);
		
		if (currentIndex === -1) {
			this.goTo(currentEmployeeId);
			return;
		}
		
		const newPage = page + 1 > pages ? pages : page + 1;
		const len = employees?.length - 1;
		const diff = len - currentIndex;

		if (newPage > page && diff <= 2) {
			if (this.fetchingNextPage) {
				this.goTo(currentEmployeeId);
				return;
			}
			this.fetchingNextPage = true;
			
			// Timeout de segurança
			const safetyTimeout = setTimeout(() => {
				if (this.fetchingNextPage) {
					console.warn('Timeout: liberando flag após 10s');
					this.fetchingNextPage = false;
				}
			}, 10000);
			
			this.fetchEmployees('0', true, () => {
				clearTimeout(safetyTimeout);
				this.fetchingNextPage = false;
				this.goTo(currentEmployeeId);
			}, newPage);
			return;
		}

		this.goTo(currentEmployeeId);
	};
	
	goToPreviousEmployee = async () => {
		const { employees } = this.state;

		const currentEmployeeId = this.form.getFieldValue("funcionario_id");
		const currentIndex = employees.findIndex((employee) => employee.id === currentEmployeeId);

		if (currentIndex <= 0) return;
	
		const previousEmployeeId = employees[currentIndex - 1]?.id;
		if (!previousEmployeeId) return;

		this.selectEmployee(previousEmployeeId, true);
	};

	goToNextCompany = () => {
		const { companies } = this.state;

		const currentCompanyId = this.form.getFieldValue("empresa_id");

		const currentIndex = companies.findIndex((company) => company.id === currentCompanyId);

		const nextCompanyId = companies[currentIndex + 1]?.id;

		if (!nextCompanyId) return;
		this.selectCompany(nextCompanyId, true);
	}

	goToPreviousCompany = () => {
		const { companies } = this.state;

		const currentCompanyId = this.form.getFieldValue("empresa_id");

		const currentIndex = companies.findIndex((company) => company.id === currentCompanyId);

		const previousCompanyId = currentIndex > 0 ? companies[currentIndex - 1]?.id : null;

		if (!previousCompanyId) return;
		this.selectCompany(previousCompanyId, true);
	}

	periodBalance = () => {
		const { dataTotal } = this.state;

		return toMinutes(dataTotal?.total_horas_extras) - toMinutes(dataTotal?.total_horas_faltas);
	}

	kpis = () => {
		const { dataTotal } = this.state;
		const hasTotals     = Object.keys(dataTotal ?? {}).length > 0;
		const value         = (key) => hasTotals ? formatHours(toMinutes(dataTotal[key])) : null;
		const balance       = this.periodBalance();

		return [
			{
				key    : "normal",
				tone   : "blue",
				icon   : <i className="fal fa-clock" />,
				title  : "Horas trabalhadas",
				value  : value("total_horas_normais"),
				caption: "Total no período",
			},
			{
				key    : "extra",
				tone   : "green",
				icon   : <i className="fal fa-chart-line" />,
				title  : "Horas extras",
				value  : value("total_horas_extras"),
				caption: "Total no período",
			},
			{
				key    : "faltas",
				tone   : "red",
				icon   : <i className="fal fa-calendar-times" />,
				title  : "Faltas",
				value  : value("total_horas_faltas"),
				caption: "Total no período",
			},
			{
				key    : "noturno",
				tone   : "violet",
				icon   : <i className="fal fa-moon" />,
				title  : "Adicional noturno",
				value  : value("total_adiconal_noturo"),
				caption: "Total no período",
			},
			{
				key    : "abono",
				tone   : "amber",
				icon   : <i className="fal fa-umbrella" />,
				title  : "Abono",
				value  : value("total_abono"),
				caption: "Total no período",
			},
			{
				key    : "saldo",
				tone   : balance < 0 ? "red" : (balance > 0 ? "green" : "neutral"),
				icon   : <i className="fal fa-balance-scale" />,
				title  : "Saldo do período",
				value  : hasTotals ? formatHours(balance) : null,
				caption: "Extras - Faltas",
			},
		];
	}

	renderSummaryCard = ({ className, icon, tone, title, footerLabel, footerValue, footerClassName, children }) => (
		<section className={`time-card-summary-card ${className || ""}`}>
			<header className="time-card-summary-header">
				<span className={`time-card-summary-icon time-card-summary-icon-${tone}`}>{icon}</span>
				<h3>{title}</h3>
			</header>
			<div className="time-card-summary-body">
				{children}
			</div>
			<footer className="time-card-summary-footer">
				<span>{footerLabel}</span>
				<strong className={footerClassName}>{footerValue}</strong>
			</footer>
		</section>
	)

	renderSummary = () => {
		const { data, dataTotal: totals, columnsList, overtimeColumns } = this.state;

		const overtime = overtimeColumns.filter(column => column.idsFaixa).map(column => ({
			periodo   : column.periodo,
			percentual: `${parseFloat(column.percentual)}%`,
			value     : this.overtimeTotal(column.idsFaixa),
		}));

		const summaryPeriods = overtimePeriods
			.map((period) => ({ ...period, items: overtime.filter((item) => item.periodo === period.key) }))
			.filter((period) => period.items.length);

		const bank = [
			{ key: "credito", title: "BCréd", caption: "Créditos", icon: <i className="fal fa-plus-circle" />, value: totals.bh_horas_extras },
			{ key: "debito", title: "BDéb", caption: "Débitos", icon: <i className="fal fa-minus-circle" />, value: totals.bh_horas_falta },
			{ key: "saldo", title: "BSaldo", caption: "Saldo acumulado", icon: <i className="fal fa-wallet" />, value: totals.bh_horas_saldo },
			{ key: "total", title: "BTotal", caption: "Crédito - débito", icon: <i className="fal fa-balance-scale" />, value: totals.bh_horas_total },
			{ key: "ajuste", title: "BAjuste", caption: "Ajustes manuais", icon: <i className="fal fa-sliders-h" />, value: totals.bh_horas_ajuste },
		].map((item) => {
			const minutes = toMinutes(item.value);

			return {
				...item,
				value: formatHours(minutes),
				tone : minutes < 0 ? "red" : (minutes > 0 ? "green" : "neutral"),
			};
		});

		const resume = [
			{ label: "Carga prevista", value: totals.total_horas_carga },
			{ label: "Horas trabalhadas", value: totals.total_horas_normais },
			{ label: "Horas extras", value: totals.total_horas_extras },
			{ label: "Adicional noturno", value: totals.total_adiconal_noturo },
			{ label: "Abono", value: totals.total_abono },
			{ label: "Faltas", value: totals.total_horas_faltas },
			{ label: "Atrasos", value: totals.total_horas_atraso },
		];

		const showBank  = !!columnsList?.banco_hora && data.some(item => item.usa_banco_horas === 1);
		const bankTotal = toMinutes(totals.bh_horas_total);
		const balance   = this.periodBalance();

		return (
			<div className={`time-card-summary ${showBank ? "has-bank" : ""}`}>
				{this.renderSummaryCard({
					icon           : <i className="fal fa-stopwatch" />,
					tone           : "blue",
					title          : "Horas extras detalhadas",
					footerLabel    : "Total horas extras",
					footerValue    : formatHours(toMinutes(totals.total_horas_extras)),
					footerClassName: "is-primary",
					children       : summaryPeriods.length > 0 ? (
						<div className="time-card-summary-groups">
							{summaryPeriods.map((period) => (
								<div key={period.key} className="time-card-summary-group">
									<span className="time-card-summary-group-title">{period.summaryLabel}</span>
									<div className="time-card-summary-values">
										{period.items.map((item, index) => (
											<div key={index} className="time-card-summary-value">
												<span>{item.percentual}</span>
												<strong>{item.value}</strong>
											</div>
										))}
									</div>
								</div>
							))}
						</div>
					) : (
						<p className="time-card-summary-empty">Nenhuma faixa de hora extra no período.</p>
					),
				})}
				{showBank && this.renderSummaryCard({
					className      : "time-card-summary-card-bank",
					icon           : <i className="fal fa-layer-group" />,
					tone           : "green",
					title          : "Banco de horas",
					footerLabel    : "Total banco de horas",
					footerValue    : formatHours(bankTotal),
					footerClassName: signClass(bankTotal),
					children       : <UIKpiCards items={bank} />,
				})}
				{this.renderSummaryCard({
					icon           : <i className="fal fa-clipboard-list" />,
					tone           : "violet",
					title          : "Resumo do período",
					footerLabel    : <>Saldo do período <small>(extras - faltas)</small></>,
					footerValue    : formatHours(balance),
					footerClassName: signClass(balance),
					children       : (
						<dl className="time-card-summary-list">
							{resume.map((item) => (
								<div key={item.label}>
									<dt>{item.label}</dt>
									<dd>{formatHours(toMinutes(item.value))}</dd>
								</div>
							))}
						</dl>
					),
				})}
			</div>
		);
	}

	renderFilters = () => {
		const {
			isLoading,
			isDisabled,
			employees,
			employeesIsLoading,
			empresa_id,
			funcionario_id,
			companies,
			dataInicial,
			dataFinal,
			dataFinalError,
			filters,
			avatar,
		} = this.state;

		const invalidPeriod = dataInicial > dataFinal;
		const employee      = employees.find((item) => item.id === funcionario_id);
		const filtersCount  = [filters.departamento_id, filters.funcao_id, filters.jornada_id, filters.status].filter(Boolean).length;

		return (
			<Form
				ref={el => this.form = el}
				layout="vertical"
				className="time-card-filters"
				scrollToFirstError
				disabled={isLoading}
				onFinish={this.onFinish}
				initialValues={{
					datainicial: moment().startOf('month'),
					datafinal: moment(),
				}}
			>
				<Form.Item label="Empresa" required className="time-card-filters-company">
					<div className="time-card-filters-nav-field">
						<Form.Item
							name="empresa_id"
							noStyle
							rules={[{ required: true, message: "Campo obrigatório." }]}
						>
							<Select
								allowClear
								filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
								notFoundContent={this.state.companiesIsLoading ? <Spin size="small" /> : null}
								onDropdownVisibleChange={(open) => open && this.fetchCompanies()}
								onSearch={this.fetchCompanies}
								onSelect={this.selectCompany}
								optionFilterProp="children"
								placeholder="Selecione a empresa"
								showSearch
								value={empresa_id}
								disabled={isDisabled || invalidPeriod}
							>
								{companies.map((company, index) => (
									<Select.Option key={index} value={company.id}>
										{company.nome}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
						<div className="time-card-filters-nav">
							<Button type="link" icon={<i className="fas fa-chevron-left" />} disabled={invalidPeriod} onClick={this.goToPreviousCompany} />
							<Button type="link" icon={<i className="fas fa-chevron-right" />} disabled={invalidPeriod} onClick={this.goToNextCompany} />
						</div>
					</div>
				</Form.Item>
				<Form.Item label="Funcionário" required className="time-card-filters-employee">
					<div className="time-card-filters-employee-field">
						<UIAvatarLabel id={funcionario_id} name={employee?.nome} avatar={avatar} showName={false} />
						<div className="time-card-filters-nav-field">
							<Form.Item
								name="funcionario_id"
								noStyle
								rules={[{ required: true, message: "Campo obrigatório." }]}
							>
								<Select
									filterOption={false}
									allowClear
									placeholder="Selecione o funcionário"
									notFoundContent={employeesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
									onSearch={this.fetchEmployees}
									onDeselect={this.fetchEmployees}
									onSelect={this.selectEmployee}
									showSearch
									disabled={isDisabled || invalidPeriod}
								>
									{employees.map((item, index) => (
										<Select.Option key={index} value={item.id}>{item.nome}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<div className="time-card-filters-nav">
								<Button type="link" icon={<i className="fas fa-chevron-left" />} disabled={this.state.isPreviousDisabled || invalidPeriod} onClick={this.goToPreviousEmployee} />
								<Button type="link" icon={<i className="fas fa-chevron-right" />} disabled={this.state.isNextDisabled || invalidPeriod} onClick={this.goToNextEmployee} />
							</div>
						</div>
					</div>
				</Form.Item>
				<div className="time-card-filters-date">
					<DatePickerWithMask
						onChange={(e) => this.setState({ dataInicial: e.format("YYYY-MM-DD") })}
						label="Data inicial"
						name="datainicial"
						required={true}
						disabled={isDisabled}
					/>
				</div>
				<div className="time-card-filters-date">
					<DatePickerWithMask
						onChange={(e) => {
							const dataFinal = e.format("YYYY-MM-DD");
							if (dataInicial > dataFinal) {
								message.error("A data final não pode ser menor que a data inicial.");
								this.setState({ dataFinal });
								this.setState({ dataFinalError: true })
								return;
							}
							this.setState({ dataFinal, dataFinalError: false }, () => {
								this.form.submit();
							});
						}}
						label="Data final"
						name="datafinal"
						disabled={isDisabled}
						required={true}
						onKeyUp={(e) => {
							if (e.keyCode === 9) {
								this.form?.datafinal.focus();
							}
						}}
						rules={[
							{
								required: true,
								message: "Campo obrigatório.",
							},
							{
								validator(_, value) {
									if (!dataFinalError) {
										return Promise.resolve();
									}
									return Promise.reject(new Error("A data final não pode ser menor que a data inicial."));
								},
							},
						]}
					/>
				</div>
				<div className="time-card-filters-actions">
					<Button
						type="default"
						className="action-btn action-btn-secondary"
						icon={<i className="fal fa-filter" />}
						onClick={this.filtersOpen}
					>
						<Badge count={filtersCount} showZero={false} offset={[8, -5]}>Filtros</Badge>
					</Button>
					<Button
						type="primary"
						htmlType="submit"
						className="action-btn"
						icon={<i className="far fa-search" />}
						loading={isDisabled}
						disabled={isDisabled || invalidPeriod}
					>
						{isDisabled ? "Consultando" : "Consultar"}
					</Button>
				</div>
			</Form>
		);
	}

	render() {
		const {
			isLoading,
			isSearching,
			data,
			allowSendToSign,
			justificationRequests,
			pontoAjusteRequests,
		} = this.state;

		const hasPendingRequests = justificationRequests?.length > 0 || pontoAjusteRequests?.length > 0;

		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header time-card-page" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						kpis={this.kpis()}
						isLoading={isLoading}
						enableSearch={false}
						showListTypeChange={false}
						appendSearch={this.renderFilters()}
						buttons={[
							{
								visible: !!allowSendToSign,
								type   : "secondary",
								onClick: this.signedCardsOpen,
								title  : "Cartões enviados",
								icon   : <i className="fal fa-envelope" />,
							},
							{
								visible: !!allowSendToSign,
								type   : "secondary",
								onClick: this.sendToSignOpen,
								title  : "Enviar para assinatura",
								icon   : <i className="fal fa-signature" />,
							},
							{
								visible: true,
								type   : "secondary",
								onClick: this.columnsOpen,
								title  : "Gerenciar colunas",
								icon   : <i className="fal fa-columns" />,
							},
							{
								visible: true,
								type   : "secondary",
								onClick: this.printOpen,
								title  : "Imprimir",
								icon   : <i className="fal fa-print" />,
							},
						]}
					>
						{hasPendingRequests && (
							<Alert
								className="time-card-alert"
								type="warning"
								showIcon
								icon={<i className="fal fa-clock" />}
								message="Há justificativa(s) e/ou marcações pendentes de aprovação"
								action={
									<Space direction="horizontal">
										<Popconfirm
											placement="topRight"
											title="Deseja aprovar todas as solicitações?"
											onConfirm={() => this.approveAllJustificationRequest(true)}
											okText="Sim"
											cancelText="Não"
										>
											<Button size="small">
												Aprovar todas
											</Button>
										</Popconfirm>
										<Button size="small" type="primary" onClick={() => {this.setState({ modalJustificationRequests: true });}}>
											Visualizar
										</Button>
									</Space>
								}
							/>
						)}
						{isSearching && (
							<Table
								onPaginationChange={this.onPaginationChange}
								data={data}
								pagination={this.state.pagination}
								dataInicial={this.state.dataInicial}
								dataFinal={this.state.dataFinal}
								columns={this.columns()}
								fetchGetAll={this.fetchGetAll}
								fetchGetItems={this.fetchGetItems}
								updateRow={this.updateRow}
								reloadRow={this.fetchGetAll}
								newJoinColumn={this.newJoinColumn}
								removeBatida={this.removeBatida}
								journeyOpen={this.journeyOpen}
							/>
						)}
						{isSearching && data.length > 0 && this.renderSummary()}
					</UIPageListing>
				</div>

				<ModalColumns
					ref={el => this.columnsScreen = el}
					visible={this.state.columnsModalVisible}
					onComplete={this.columnsOnComplete}
					onClose={this.columnsOnClose}
				/>
				<ModalCreate
					ref={el => this.createScreen = el}
					onComplete={this.createOnComplete}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					onComplete={this.editOnComplete}
				/>
				<ModalDiscard
					ref={el => this.discardScreen = el}
					onComplete={this.discardOnComplete}
				/>
				<ModalAjustes
					ref={el => this.ajustesScreen = el}
					visible={this.state.ajustesModalVisible}
					onComplete={this.ajustesOnComplete}
					onClose={this.ajustesOnClose}
				/>
				<ModalBancoAjustes
					ref={el => this.bancoAjustesScreen = el}
					visible={this.state.bancoAjustesModalVisible}
					onComplete={this.bancoAjustesOnComplete}
					onClose={this.bancoAjustesOnClose}
					empresa_id={this.state.empresa_id}
					funcionario_id={this.state.funcionario_id}
					currentEmployeeDepartment={this.state.currentEmployeeDepartment}
				/>
				<ModalJourneyShow
					ref={el => this.journeyShowScreen = el}
					visible={this.state.journeyShowModalVisible}
					onClose={this.journeyOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>

				{this.state.modalSendToSignVisible && 	
					<ModalSendToSign 
						ref={el => this.sendToSignScreen = el}
						visible={this.state.modalSendToSignVisible}
						onClose={this.sendToSignClose}
						empresa_id={this.state.empresa_id}
						funcionario_id={this.state.funcionario_id}
						data_inicial={this.state.dataInicial}
						data_final={this.state.dataFinal}
					/>
				}

				{this.state.modalSignedCardsVisible &&				
					<ModalListSigned 
						visible={this.state.modalSignedCardsVisible}
						onClose={this.signedCardsClose}
						empresa_id={this.state.empresa_id}
						funcionario_id={this.state.funcionario_id}
						data_inicial={this.state.dataInicial}
						data_final={this.state.dataFinal}
					/>
				}

				{this.state.modalJustificationRequests &&
					<ModalJustificationRequest 
						visible={this.state.modalJustificationRequests}
						onClose={this.justificationRequestsClose}
						justificationRequests={this.state.justificationRequests}
						pontoAjusteRequests={this.state.pontoAjusteRequests}
						fetchJustifications={() => {
							this.fetchSolicitacoesJustificativas();
							this.fetchSolicitacoesPontoAjuste();
						}}
						approveJustifications={this.approveAllJustificationRequest}
						loadingApproveAll={this.state.loadingApproveRequests}
						loadingRejectAll={this.state.loadingRejectRequests}
					/>
				}
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps, null)(withRouter(Index));
